import { ResourceServiceContext } from "@core-ui/ContextServices/ResourceService/store/ResourceStore.provider";
import deleteDiagrams from "@ext/markdown/elements/diagrams/logic/deleteDiagrams";
import deleteDrawio from "@ext/markdown/elements/drawio/edit/logic/deleteDrawio";
import deleteFiles from "@ext/markdown/elements/file/edit/logic/deleteFiles";
import deleteImages from "@ext/markdown/elements/image/edit/logic/deleteImages";
import deleteOpenApi from "@ext/markdown/elements/openApi/edit/logic/deleteOpenApi";
import type { Mark } from "@tiptap/pm/model";
import type { Node } from "prosemirror-model";
import { useCallback, useContext } from "react";

const useContentEditorHooks = () => {
	const resourceService = useContext(ResourceServiceContext);

	const onDeleteNodes = useCallback(
		(nodes: Node[]): void => {
			void deleteImages(nodes, resourceService);
			void deleteDrawio(nodes, resourceService);
			void deleteOpenApi(nodes, resourceService);
			void deleteDiagrams(nodes, resourceService);
		},
		[resourceService],
	);

	const onDeleteMarks = useCallback(
		(marks: Mark[]): void => {
			void deleteFiles(marks, resourceService);
		},
		[resourceService],
	);

	const onAddMarks = useCallback((): void => {}, []);

	return { onDeleteNodes, onDeleteMarks, onAddMarks };
};

export default useContentEditorHooks;
